// Category aggregation and the colour palette of the old app
// (`ColorsUtil`): every category of the current list gets `catNum<i>`;
// the solid variant `catNum<i>d` is used for swatches and pie slices.

const PALETTE: [number, number, number][] = [
  [57, 59, 121], [214, 39, 40], [165, 80, 148], [82, 84, 163], [107, 110, 207], [156, 158, 222], [99, 121, 57], [140, 162, 82],
  [181, 207, 107], [206, 219, 155], [140, 109, 49], [189, 158, 57], [231, 186, 82], [231, 203, 148], [132, 59, 57], [173, 73, 74],
  [214, 97, 107], [231, 150, 156], [123, 65, 115], [206, 109, 189], [206, 109, 189], [222, 158, 214], [99, 99, 99], [23, 190, 207],
  [255, 127, 13], [255, 0, 0], [0, 255, 0], [0, 0, 255], [255, 127, 127], [127, 255, 127], [127, 127, 255], [200, 200, 200],
  [1, 0, 103], [213, 255, 0], [255, 0, 86], [158, 0, 142], [14, 76, 161], [255, 229, 2], [0, 95, 57], [0, 255, 0], [149, 0, 58],
  [255, 147, 126], [164, 36, 0], [0, 21, 68], [145, 208, 203], [98, 14, 0], [107, 104, 130], [0, 0, 255], [0, 125, 181], [106, 130, 108],
  [0, 174, 126], [194, 140, 159], [190, 153, 112], [0, 143, 156], [95, 173, 78], [255, 0, 0], [255, 0, 246], [255, 2, 157], [104, 61, 59],
  [255, 116, 163], [150, 138, 232], [152, 255, 82], [167, 87, 64], [1, 255, 254], [255, 238, 232], [254, 137, 0], [189, 198, 255],
  [1, 208, 255], [187, 136, 0], [117, 68, 177], [165, 255, 210], [255, 166, 254], [119, 77, 0], [122, 71, 130], [38, 52, 0], [0, 71, 84],
  [67, 0, 44], [181, 0, 255], [255, 177, 103], [255, 219, 102], [144, 251, 146], [126, 45, 210], [189, 211, 147], [229, 111, 254],
  [222, 255, 116], [0, 255, 120], [0, 155, 255], [0, 100, 1], [0, 118, 255], [133, 169, 0], [0, 185, 23], [120, 130, 49], [0, 255, 198],
  [255, 110, 65], [232, 94, 190],
];

export function paletteColor(index: number): string {
  const [r, g, b] = PALETTE[index % PALETTE.length];
  return `rgb(${r},${g},${b})`;
}

export function paletteCss(): string {
  return PALETTE.map(([r, g, b], i) => `.catNum${i}d{background-color:rgb(${r},${g},${b});fill:rgb(${r},${g},${b});} .catNum${i}{background-color:rgba(${r},${g},${b},0.5);fill:rgb(${r},${g},${b});}`).join(" ");
}

let injected = false;
/** Add the `catNum` classes to the document once (the old `addCssColors`). */
export function ensurePaletteStyles() {
  if (injected || typeof document === "undefined") return;
  const style = document.createElement("style");
  style.textContent = paletteCss();
  document.head.appendChild(style);
  injected = true;
}

export type CategoryData = {
  name: string;
  grams: number;
  worn: number;
  consumable: number;
  index: number;
  cssClass: string;
};

export type Weighted = { category: string; grams: number; quantity: number; worn: boolean; consumable: boolean };

/** Aggregate lines by category in first-seen order (that is how the old model numbered them). */
export function categorize(lines: Weighted[]): CategoryData[] {
  const map = new Map<string, CategoryData>();
  for (const l of lines) {
    let cat = map.get(l.category);
    if (!cat) {
      cat = { name: l.category, grams: 0, worn: 0, consumable: 0, index: map.size, cssClass: `catNum${map.size}` };
      map.set(l.category, cat);
    }
    const w = l.grams * l.quantity;
    cat.grams += w;
    if (l.worn) cat.worn += w;
    if (l.consumable) cat.consumable += w;
  }
  return [...map.values()];
}

export function categoryLabel(name: string): string {
  const t = name.trim();
  return t === "" ? "None" : t;
}
